/* import __COLOCATED_TEMPLATE__ from './gundersen-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import dayjs from 'dayjs';

export default class GundersenCardComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked classGroup;
	@tracked startOffset = 15;
	@tracked pointsColumn = 1;
	
	@action
	async classGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.classGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.classGroup = classGroup;
		}
	}
	
	@action
	pointsColumnChanged(browserEvent)
	{
		this.pointsColumn = browserEvent.target.value;
	}
	
	@action
	async setStartTimes()
	{		
		//get current time
		var currentTime = dayjs();
		//zero milliseconds on current time
		currentTime.millisecond(0);
		//add start offset to current time
		currentTime.add(this.startOffset,"seconds");
		
		var classes = await this.classGroup.get('classes');
		for(var cl of [...classes])
		{
			var entries = await cl.get('entries');
			for(var entry of [...entries])
			{
				var entryStartOffset = 0;
				if(this.pointsColumn == 1)
				{
					entryStartOffset = entry.pts1;
				}
				if(this.pointsColumn == 2)
				{
					entryStartOffset = entry.pts2;
				}
				if(this.pointsColumn == 3)
				{
					entryStartOffset = entry.pts3;
				}
				if(this.pointsColumn == 4)
				{
					entryStartOffset = entry.pts4;
				}
				if(this.pointsColumn == 5)
				{
					entryStartOffset = entry.pts5;
				}
				var newStartTime = dayjs(currentTime);
				newStartTime.add(entryStartOffset,"seconds");
				var entrySTR = await entry.get("StartTimingRecordId");
				newStartTime = newStartTime.toDate();
				entrySTR.assignedStartTime = newStartTime;
				console.log(entrySTR.assignedStartTime);
				entrySTR.save();
			}
		}
		//for each entry
			//get offset
			//add offset to zero time
			//set start time to calculated time
	}
}